import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    
};

const getters = {
    
};

const actions = {
    async getNavigation( context, data ){
        return await axios.post(`${backendUrl()}/getNavigation`, data,
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async updateNavigation( context, data ) {
        return await axios.post(`${backendUrl()}/updateNavigation`, data, 
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getUpdatedNavigation', this.getters.getUserLevel)
            return response.data
        })
    },

    async createNewLink( context, data ) {
        await axios.post(`${backendUrl()}/createNewLink`, data,
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getUpdatedNavigation', this.getters.getUserLevel)
        })
    },

    async deleteLink( context, data ) {
        await axios.post(`${backendUrl()}/deleteLink`,
        {
            linkId: data
        },
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getUpdatedNavigation', this.getters.getUserLevel)
        })
    },

    async getUpdatedNavigation( context, data ) {
        await axios.post(`${backendUrl()}/getUpdatedNavigation`, 
        {
            currentUserLevel: data
        },
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.commit('setNavigation', response.data.updatedNavigation, {root: true})
            context.commit('setAllowedNavigation', response.data.allowedNavigation, {root: true})
        })
    }
};

const mutations = {

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


